<template>
  <div v-if="!childData.lastLevel">
    <el-collapse>
      <el-collapse-item
        v-for="(tpll, indexx) in childData.children"
        :key="indexx"
        :class="tpll.className"
        :title="`• ${tpll.title}`"
        :name="indexx"
      >
        <template slot="title">
          <div
            style="display:flex;justify-content: space-between;width: 100%;padding-right: 30px;"
          >
            <span :title="tpll.title"> • {{ tpll.title }} </span>
            <span>
              <i
                class="el-icon-circle-plus-outline jia"
                style="font-size:20px;color:#757575"
              ></i>
            </span>
          </div>
        </template>
        <template
          v-if="
            tpll.children ? (tpll.children.length > 0 ? true : false) : false
          "
        >
          <email-child :childData="tpll" @AlertModal="search"></email-child>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
  <div v-else>
    <div
      v-for="(tpll, indexx) in childData.children"
      class="search"
      style="background-color:#eff6fb;"
      :key="indexx"
      :title="tpll.title"
    >
      • {{ tpll.title }}
      <span @click="search(tpll)" class="search-btn"
        ><i class="el-icon-search"></i
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "email-child",
  props: ["childData"],
  data() {
    return {};
  },
  methods: {
    search(content) {
      this.$emit("AlertModal", content);
    },
  },
};
</script>
